export default "__VITE_ASSET__DB_4Tk41__"